import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginScreen from './pages/LoginScreen';
import HomeScreen from './pages/HomeScreen'; // Importe o novo componente Home
import NfseControlScreen from './pages/NfseControlScreen'; // Importe o novo componente
import DocumentsAndDarfsScreen from './pages/DocumentsAndDarfsScreen';
import BoletoControlScreen from './pages/BoletoControlScreen';
import ClienteControlScreen from './pages/ClienteControlScreen';
import ConfigurationScreen from './pages/ConfigurationScreen';
import { Toaster } from 'react-hot-toast';
import LogScreen from './pages/LogScreen'; // Importe o novo componente
import ImportarOfxPage from './pages/ImportarOfxPage';
import EmConstrucaoPage from './pages/EmConstrucaoPage';

// Componente simples para simular uma rota protegida
// Em um projeto real, você teria uma lógica de autenticação mais robusta aqui.
const ProtectedRoute = ({ children }) => {
  const userToken = localStorage.getItem('userToken'); // Verifica se há um token
  return userToken ? children : <Navigate to="/" />;
};

function App() {
  return (
    <>

      <Router>
        <Routes>
          <Route path="/" element={<LoginScreen />} />

          {/* Rota Protegida para a Home */}
          {/* O usuário só acessará a Home se tiver um token no localStorage */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <HomeScreen />
              </ProtectedRoute>
            }
          />

          {/* Rotas para as futuras seções */}

          {/* Rota para o Controle de NFS-e */}
          <Route
            path="/nfs-e"
            element={
              <ProtectedRoute>
                <NfseControlScreen />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cambio"
            element={
              <ProtectedRoute>
                <HomeScreen />
              </ProtectedRoute>
            }
          />
          <Route
            path="/documentos"
            element={
              <ProtectedRoute>
                <DocumentsAndDarfsScreen />
              </ProtectedRoute>
            }
          />

          <Route
            path="/financeiro"
            element={
              <ProtectedRoute>
                <BoletoControlScreen />
              </ProtectedRoute>
            }
          />

          <Route
            path="/clientes"
            element={
              <ProtectedRoute>
                <ClienteControlScreen />
              </ProtectedRoute>
            }
          />

          <Route
            path="/configuration"
            element={
              <ProtectedRoute>
                <ConfigurationScreen />
              </ProtectedRoute>
            }
          />

          <Route
            path="/logs"
            element={
              <ProtectedRoute>
                <LogScreen />
              </ProtectedRoute>
            }
          />

          <Route
            path="/contacorrente"
            element={
              <ProtectedRoute>
                <ImportarOfxPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/emConstrucao"
            element={
              <ProtectedRoute>
                <EmConstrucaoPage />
              </ProtectedRoute>
            }
          />

          {/* Adicione uma rota para 404 Not Found (opcional) */}
          <Route path="*" element={<div>404 - Página Não Encontrada</div>} />

        </Routes>
      </Router>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: { fontSize: 14 }
        }}
      />

    </>
  );
}

export default App;